@if (isDefaultView()) {
  <app-course-header [courseState]="courseState" (clickEvent)="actionEvent($event)"></app-course-header>
}
<div class="px-4">
  <app-course-heading (changeHistory)="changeHistoryDrawer.open()"></app-course-heading>
</div>
<div class="course-intended p-4">
  @if (isDefaultView()) {
    <app-common-tab-menu [items]="tabItems" title="Overview"></app-common-tab-menu>
  }
  @if ({formTierFields: formTierFields$ | async, courseId: courseId$ | async}; as vm) {
    <div class="card my-4 block rounded-[10px] border border-neutral-100 px-6 py-9">
      <div class="flex justify-between">
        <div class="flex flex-col">
          <h3 class="text-lg text-black">Price</h3>
          <p class="text-base text-neutral-400">Selected Price Tiers to enroll this course</p>
        </div>
        <div class="form flex items-center gap-3">
          @if (isLoadingPrice) {
            <ng-container *ngTemplateOutlet="loader"></ng-container>
          }
          <form [formGroup]="formTier">
            <formly-form [form]="formTier" [fields]="vm.formTierFields ?? []" [model]="formTierModel">
            </formly-form>
          </form>
          <!-- <button class="btn border-0 bg-blue-100 text-blue-500 mt-2.5">Give a Reason</button> -->
        </div>
      </div>
    </div>
  }
</div>

<!-- Price loader -->
<ng-template #loader>
  <div class="flex items-center justify-center w-full">
    <div class="loader">
      <svg class="text-blue-500 m-auto h-8 w-8 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none"
        viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
        </path>
      </svg>
    </div>
  </div>
</ng-template>

<!-- Buyer drawer -->
<app-drawer #changeHistoryDrawer customClass="max-w-[600px] !sm:w-full">
  <ng-container header>
    <div class="px-6 py-5 bg-neutral-50 flex justify-between items-center border-b border-b-neutral-100">
      <h3 class="text-xl text-black font-semibold">Version History</h3>
      <div class="flex justify-between items-center gap-3">
        <button (click)="changeHistoryDrawer.close()" class="bg-neutral-100 rounded-[3px] w-6 h-6">
          <svg-icon src="@assets/images/icons/x-mark.svg" class="text-black w-3 h-3">
          </svg-icon>
        </button>
      </div>
    </div>
  </ng-container>
  <ng-container content>
    @if (changeHistoryDrawer.isOpened()) {
      <ng-container content>
        <app-common-history-course maxHeight="90vh"></app-common-history-course>
      </ng-container>
    }
  </ng-container>
</app-drawer>